import { providers } from '../../providers';
import { kie_suno } from '../kie_suno/index';
import type { TersaSpeechModel } from '../types';

// 系数
const COST_FACTOR = 2;

export const sunoModels: Record<string, TersaSpeechModel> = {
    'suno-v5.5': {
        hideLyricsVoices: ['Instrumental Mode'],
        lyricsLabel: 'Lyrics',
        lyricsPlaceholder: 'Leave empty to let the model write lyrics',
        chef: providers.suno,
        providers: [
            {
                ...providers.suno,
                model: kie_suno.speech('suno-v5.5-generate'),
                getCost: () => {
                    return 0.06 * COST_FACTOR;
                },
            },
        ],
        voices: ['lyrics', 'Music Mode', 'Instrumental Mode'],
        precheck: ['prompt'],
        supportsInput: ['t2m'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'suno-v5': {
        chef: providers.suno,
        hideLyricsVoices: ['Instrumental Mode'],
        lyricsLabel: 'Lyrics',
        lyricsPlaceholder: 'Leave empty to let the model write lyrics',
        providers: [
            {
                ...providers.suno,
                model: kie_suno.speech('suno-v5-generate'),
                getCost: () => {
                    return 0.06 * COST_FACTOR;
                },
            },
        ],
        voices: ['lyrics', 'Music Mode', 'Instrumental Mode'],
        precheck: ['prompt'],
        supportsInput: ['t2m'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};